import React, { useState, useMemo, useEffect, useRef } from "react";
import { Container, Box, Typography, makeStyles } from "@material-ui/core";
import D from "../../assets/img/bg-auth.svg";
import { FTLTextField, FTLButton, FTLPasswordField, FTLLogoIcon, typography, palette, SnackbarContainer, DialogContainer, ErrorContainer, } from "ftl-dashboards-ui-kit";
import { useAuthContext } from "ftl-auth-module";
import { useHistory, Link } from "react-router-dom";
import { errorService, FTLDateUtils, } from "ftl-dashboards-core";
export const FTLAuthPage = ({ title, redirectOnAuthUrl }) => {
    const { state, dispatch } = useAuthContext();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const history = useHistory();
    const firstRenderRef = useRef(true);
    const errorResponse = useMemo(() => { var _a; return (_a = state.errors) === null || _a === void 0 ? void 0 : _a.find((error) => error.presentationData.message); }, [state.errors]);
    const handleOnAuth = (e) => {
        e.preventDefault();
        dispatch({
            type: "SIGN_IN",
            payload: {
                loginField: {
                    propName: "email",
                    value: email,
                },
                passwordField: {
                    propName: "password",
                    value: password,
                },
            },
        });
    };
    const classes = useStyles();
    const emailHasError = (errorResponse === null || errorResponse === void 0 ? void 0 : errorResponse.details) === "INVALID_EMAIL" ||
        (errorResponse === null || errorResponse === void 0 ? void 0 : errorResponse.details) === "INVALID_DATA";
    const passwordHasError = (errorResponse === null || errorResponse === void 0 ? void 0 : errorResponse.details) === "INVALID_DATA" ||
        (errorResponse === null || errorResponse === void 0 ? void 0 : errorResponse.details) === "INVALID_PASSWORD";
    useEffect(() => {
        if (state.isAuth && redirectOnAuthUrl && firstRenderRef.current === false) {
            return history.push(redirectOnAuthUrl);
        }
        firstRenderRef.current = false;
    }, [state.isAuth, state.accessToken, state.refreshToken]);
    useEffect(() => {
        var _a;
        if (((_a = state.errors) === null || _a === void 0 ? void 0 : _a.length) && state.isLoading === false)
            errorService.showError({
                error: state.errors[0],
            });
    }, [state.isLoading]);
    return (React.createElement(ErrorContainer, null,
        React.createElement(Box, { style: {
                backgroundImage: `url(${D})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "bottom",
                backgroundSize: "100% auto",
            } },
            React.createElement(Container, { maxWidth: "md", disableGutters: true, classes: {
                    maxWidthXs: classes.maxWidthXs,
                } },
                React.createElement(Box, { display: "flex", justifyContent: "center" },
                    React.createElement(Box, { display: "flex", justifyContent: "center", flexDirection: "column", height: "calc(100vh - 40px)", mb: "40px" },
                        React.createElement(Box, { margin: "auto auto 0" },
                            React.createElement(Box, { textAlign: "center" },
                                React.createElement(FTLLogoIcon, null)),
                            React.createElement(Box, { mt: 6 },
                                React.createElement(Typography, { variant: "h3" }, title))),
                        React.createElement(Box, { mt: 6 },
                            React.createElement("form", { noValidate: true, onSubmit: handleOnAuth },
                                React.createElement(Box, { width: "280px" },
                                    React.createElement(FTLTextField, { name: "email", fullWidth: true, label: "Email", autoComplete: "on", value: email, type: "email", onChange: (e) => setEmail(e.target.value), error: emailHasError })),
                                React.createElement(Box, { width: "280px", mt: 6 },
                                    React.createElement(FTLPasswordField, { fullWidth: true, name: "password", label: "\u041F\u0430\u0440\u043E\u043B\u044C", onChange: (e) => setPassword(e.target.value), error: passwordHasError })),
                                React.createElement(Box, { mt: 6 },
                                    React.createElement(FTLButton, { fullWidth: true, async: state.isLoading, color: "primary", type: "submit", size: "large" }, "\u0412\u043E\u0439\u0442\u0438")))),
                        React.createElement(Box, { mt: 12, marginLeft: "auto", marginRight: "auto", display: "flex" },
                            React.createElement(Box, null,
                                React.createElement(Link, { to: "/" },
                                    React.createElement(Typography, { style: Object.assign(Object.assign({}, typography.unsupportedSemanticTags.lawExplanations), { color: palette.link.secondary }) }, "\u041A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u044C"))),
                            React.createElement(Box, { ml: 4 },
                                React.createElement(Link, { to: "/" },
                                    React.createElement(Typography, { style: Object.assign(Object.assign({}, typography.unsupportedSemanticTags.lawExplanations), { color: palette.link.secondary }) }, "\u0411\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u044C")))),
                        React.createElement(Box, { mt: "auto" },
                            React.createElement(Link, { to: "/" },
                                React.createElement(Typography, { align: "center", style: Object.assign(Object.assign({}, typography.unsupportedSemanticTags.lawExplanations), { color: palette.link.secondary }) },
                                    "\u00A9",
                                    FTLDateUtils.currentYear,
                                    " FoodTech Lab")))))),
            React.createElement(SnackbarContainer, null),
            React.createElement(DialogContainer, null))));
};
const useStyles = makeStyles((theme) => ({
    maxWidthXs: {
        maxWidth: 280,
    },
}));
export default FTLAuthPage;
//# sourceMappingURL=index.js.map